export interface DevAuthEnv {
  [key: string]: string | undefined
  NODE_ENV?: string
  DEV_AUTH_BYPASS?: string
  VITE_DEV_AUTH_BYPASS?: string
  DEV_AUTH_UID?: string
  VITE_DEV_AUTH_UID?: string
  DEV_AUTH_EMAIL?: string
  VITE_DEV_AUTH_EMAIL?: string
  DEV_AUTH_DISPLAY_NAME?: string
  VITE_DEV_AUTH_DISPLAY_NAME?: string
  DEV_AUTH_PHOTO_URL?: string
  VITE_DEV_AUTH_PHOTO_URL?: string
}

export interface DevAuthUser {
  uid: string
  email: string
  displayName: string
  photoURL: string | null
}

export const DEV_AUTH_TOKEN = 'dev-auth-bypass'

function normalize(value: string | undefined): string | undefined {
  const trimmed = value?.trim()
  return trimmed ? trimmed : undefined
}

function pickEnvValue(env: DevAuthEnv, key: keyof DevAuthEnv, viteKey: keyof DevAuthEnv): string | undefined {
  return normalize(env[key] ?? env[viteKey])
}

function isEnabled(value: string | undefined): boolean {
  if (!value) return false
  return value === '1' || value.toLowerCase() === 'true'
}

export function isDevAuthBypassEnabled(env: DevAuthEnv): boolean {
  if (env.NODE_ENV === 'production') return false
  return isEnabled(pickEnvValue(env, 'DEV_AUTH_BYPASS', 'VITE_DEV_AUTH_BYPASS'))
}

export function getDevAuthUser(env: DevAuthEnv): DevAuthUser {
  return {
    uid: pickEnvValue(env, 'DEV_AUTH_UID', 'VITE_DEV_AUTH_UID') ?? 'dev-auth-user',
    email: pickEnvValue(env, 'DEV_AUTH_EMAIL', 'VITE_DEV_AUTH_EMAIL') ?? 'dev@globalcomix.com',
    displayName: pickEnvValue(env, 'DEV_AUTH_DISPLAY_NAME', 'VITE_DEV_AUTH_DISPLAY_NAME') ?? 'Dev User',
    photoURL: pickEnvValue(env, 'DEV_AUTH_PHOTO_URL', 'VITE_DEV_AUTH_PHOTO_URL') ?? null,
  }
}

export function getDevAuthToken(env: DevAuthEnv): string | null {
  return isDevAuthBypassEnabled(env) ? DEV_AUTH_TOKEN : null
}
